import React from 'react';

// Icon mapping based on matière code/name keywords
const getMatiereIcon = (code, name) => {
    const key = `${code || ''} ${name?.fr || ''} ${name?.en || ''}`.toLowerCase();

    // Air Law / Droit aérien
    if (key.match(/droit|law|leg|regl/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" /></svg>
    );
    // Meteorology
    if (key.match(/met[eé]o|weather|meteo/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" /></svg>
    );
    // Navigation
    if (key.match(/nav/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" /></svg>
    );
    // Instruments / IFR
    if (key.match(/instrum|ifr|vol aux/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    );
    // Human Factors
    if (key.match(/humain|human|facteur|factor/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
    );
    // Performance
    if (key.match(/perf/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>
    );
    // Procedures / Operations
    if (key.match(/proc[eé]d|op[eé]ra|ops/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>
    );
    // General Knowledge / Connaissances générales
    if (key.match(/connais|general|g[eé]n[eé]r/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
    );
    // Structures / Cellule
    if (key.match(/struct|cellul|airframe/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>
    );
    // Communications / Radio
    if (key.match(/commun|radio/)) return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" /></svg>
    );
    // Default: academic cap
    return (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" /></svg>
    );
};

const ExamResults = ({
    passingScore,
    setIsReviewMode,
    showRestartModal,
    setShowRestartModal,
    onRestart,
    questions,
    answers,
    onDemandAnswers,
    stopExam,
    setCurrentQuestionIndex,
    language,
    matiereResults,
    minSubScore,
    category,
    isQuiz = false
}) => {

    const correctCount = questions.reduce((acc, q) => {
        const secret = onDemandAnswers[q.id];
        const userAns = answers[q.id];
        return acc + (userAns !== undefined && secret && String(userAns) === String(secret.correctReponseId) ? 1 : 0);
    }, 0);

    const score = questions.length > 0 ? Math.round((correctCount / questions.length) * 100) : 0;

    const isComplet = category === 'complet' || category === 'full';
    const overallScoreOk = isQuiz ? true : score >= passingScore;
    const allMatieresOk = isComplet && matiereResults && minSubScore > 0
        ? matiereResults.every(m => m.passed)
        : true;
    const success = isQuiz ? true : (overallScoreOk && allMatieresOk);

    const getFailureMessage = () => {
        if (!overallScoreOk && isComplet && matiereResults && !allMatieresOk) {
            return language === 'fr'
                ? 'Score global et score par matière insuffisants.'
                : 'Overall score and per-subject scores are insufficient.';
        }
        if (!overallScoreOk) {
            return language === 'fr'
                ? `Score minimum requis : ${passingScore}%`
                : `Minimum required score: ${passingScore}%`;
        }
        if (!allMatieresOk) {
            return language === 'fr'
                ? 'Score global suffisant mais une ou plusieurs matières sont en échec.'
                : 'Overall score sufficient but one or more subjects failed.';
        }
        return '';
    };

    return (
        <div className="fixed inset-0 bg-gray-50 dark:bg-black text-gray-900 dark:text-white flex flex-col items-center p-8 overflow-y-auto custom-scrollbar transition-colors duration-500">
            <div className="max-w-md w-full text-center space-y-6 my-auto py-8">
                {/* Score circle */}
                <div className={`w-28 h-28 mx-auto rounded-full flex items-center justify-center text-4xl font-bold border-4 ${isQuiz ? 'border-blue-500 text-blue-500' : (success ? 'border-emerald-500 text-emerald-500' : 'border-red-500 text-red-500')}`}>
                    {score}%
                </div>

                {/* Title + subtitle */}
                <div>
                    <h2 className="text-2xl font-bold mb-1">
                        {isQuiz
                            ? (language === 'fr' ? 'Quiz terminé' : 'Quiz Complete')
                            : (success
                                ? (language === 'fr' ? 'Félicitations !' : 'Congratulations!')
                                : (language === 'fr' ? 'Échec' : 'Try Again'))
                        }
                    </h2>
                    <p className="text-gray-500 dark:text-gray-400 text-sm">
                        {language === 'fr'
                            ? `${correctCount} bonnes réponses sur ${questions.length}`
                            : `${correctCount} correct out of ${questions.length}`
                        }
                    </p>
                    {!success && (
                        <p className="text-red-500 dark:text-red-400 text-xs mt-1.5 font-medium">
                            {getFailureMessage()}
                        </p>
                    )}
                </div>

                {/* Per-matière breakdown */}
                {isComplet && minSubScore > 0 && matiereResults && matiereResults.length > 0 && (
                    <div className="text-left bg-white dark:bg-white/5 rounded-2xl p-4 border border-gray-200 dark:border-white/10">
                        <h3 className="text-[10px] font-black uppercase tracking-widest text-gray-500 dark:text-white/50 mb-3">
                            {language === 'fr' ? 'Résultats par matière' : 'Results by subject'}
                        </h3>
                        <div className="space-y-1.5">
                            {matiereResults.map((m) => (
                                <div
                                    key={m.id}
                                    className={`flex items-center gap-2.5 px-3 py-2 rounded-xl ${
                                        m.passed
                                            ? 'bg-emerald-50 dark:bg-emerald-500/5'
                                            : 'bg-red-50 dark:bg-red-500/10'
                                    }`}
                                >
                                    {/* Subject icon */}
                                    <div className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${
                                        m.passed
                                            ? 'bg-emerald-500/10 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-400'
                                            : 'bg-red-500/10 text-red-600 dark:bg-red-500/20 dark:text-red-400'
                                    }`}>
                                        {getMatiereIcon(m.code, m.name)}
                                    </div>

                                    {/* Subject name */}
                                    <span className="flex-1 text-sm font-medium text-gray-900 dark:text-white truncate">
                                        {language === 'fr' ? m.name.fr : m.name.en}
                                    </span>

                                    {/* Score fraction */}
                                    <span className="text-[11px] text-gray-400 dark:text-gray-500 font-medium tabular-nums">
                                        {m.correct}/{m.total}
                                    </span>

                                    {/* Percentage + pass/fail */}
                                    <div className="flex items-center gap-1.5 min-w-[3.5rem] justify-end">
                                        <span className={`text-sm font-bold tabular-nums ${
                                            m.passed
                                                ? 'text-emerald-600 dark:text-emerald-400'
                                                : 'text-red-600 dark:text-red-400'
                                        }`}>
                                            {m.score}%
                                        </span>
                                        {m.passed ? (
                                            <svg className="w-3.5 h-3.5 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                        ) : (
                                            <svg className="w-3.5 h-3.5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                            </svg>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        {minSubScore > 0 && (
                            <p className="text-[10px] text-gray-400 dark:text-gray-500 mt-3 text-center">
                                {language === 'fr'
                                    ? `Minimum requis par matière : ${minSubScore}%`
                                    : `Minimum required per subject: ${minSubScore}%`
                                }
                            </p>
                        )}
                    </div>
                )}

                {/* Action buttons */}
                <div className="grid grid-cols-1 gap-3 pt-2">
                    <button
                        onClick={() => {
                            setIsReviewMode(true);
                            setCurrentQuestionIndex(0);
                        }}
                        className="w-full py-3.5 bg-blue-500 text-white rounded-2xl font-bold text-lg hover:bg-blue-600 transition transform hover:scale-[1.02] shadow-lg shadow-blue-500/20"
                    >
                        {language === 'fr' ? 'Revoir les questions' : 'Review Questions'}
                    </button>
                    <button
                        onClick={() => setShowRestartModal(true)}
                        className="w-full py-3.5 bg-white dark:bg-white text-gray-900 dark:text-black rounded-2xl font-bold text-lg hover:bg-gray-100 dark:hover:bg-gray-200 transition transform hover:scale-[1.02] border border-gray-200 dark:border-transparent shadow-sm"
                    >
                        {language === 'fr' ? 'Recommencer' : 'Restart'}
                    </button>
                    <button
                        onClick={async () => {
                            await stopExam();
                        }}
                        className="w-full py-3.5 bg-gray-200 dark:bg-white/10 rounded-2xl font-bold text-lg text-gray-900 dark:text-white hover:bg-gray-300 dark:hover:bg-white/20 transition"
                    >
                        {language === 'fr' ? 'Quitter' : 'Exit'}
                    </button>
                </div>
            </div>

            {/* Restart Modal */}
            {showRestartModal && (
                <div className="fixed inset-0 z-[150] flex items-center justify-center p-6 bg-black/80 backdrop-blur-md animate-in fade-in duration-300">
                    <div className="bg-white dark:bg-gray-900 rounded-3xl p-8 max-w-md w-full border border-gray-200 dark:border-white/10 shadow-2xl">
                        <h3 className="text-2xl font-bold mb-6 text-center text-gray-900 dark:text-white">
                            {language === 'fr' ? 'Nouveau départ' : 'New Start'}
                        </h3>
                        <div className="space-y-4">
                            <button onClick={() => onRestart('flash')} className="w-full p-4 bg-emerald-500 text-white rounded-2xl font-bold hover:bg-emerald-600 transition">{language === 'fr' ? 'Mode question-réponse' : 'Flashcard Mode'}</button>
                            <button onClick={() => onRestart('classic')} className="w-full p-4 bg-blue-500 text-white rounded-2xl font-bold hover:bg-blue-600 transition">{language === 'fr' ? 'Mode examen' : 'Exam Mode'}</button>
                            <button onClick={() => setShowRestartModal(false)} className="w-full p-3 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition mt-2">{language === 'fr' ? 'Annuler' : 'Cancel'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExamResults;
